/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { useLocalization as v } from "@progress/kendo-react-intl";
import { pagerItemPerPage as P, pagerPageSizeAriaLabel as h } from "../messages/index.mjs";
import { DropDownList as S } from "@progress/kendo-react-dropdowns";
import { getL10NMessage as r, translateMessage as l } from "./utils.mjs";
const C = (a) => {
  const { value: t, pageSizes: m, pageSize: s, messagesMap: g, size: p, navigatable: c } = a, i = m.slice(), o = v();
  t === void 0 && i.filter((e) => e === s).length === 0 && i.unshift(s);
  const z = r(P, g), f = r(h, g), u = (e) => {
    a.pageChange && a.pageChange({ skip: 0, take: parseInt(e.target.value, 10) }, e);
  };
  return /* @__PURE__ */ n.createElement("span", { className: "k-pager-sizes" }, /* @__PURE__ */ n.createElement(
    S,
    {
      value: t !== void 0 ? t : s,
      data: i,
      onChange: u,
      ariaLabel: l(o, f),
      size: p,
      tabIndex: c ? -1 : void 0
    }
  ), /* @__PURE__ */ n.createElement("span", null, l(o, z)));
};
export {
  C as PagerPageSizes
};
